import React from 'react';
import { EditIcon, TrashOutlineIcon } from '../../../../../../../components/buttons/IconButtons';
import ButtonIcon from '../../../../../../../components/buttons/ButtonIcon';
import NotInformation from '../../../../../../../components/NotInformation';
import CustomButtonLink from '../../../../../../../components/buttons/CustomButtonLink';
import DeleteModal from '../../../../../../Modals/DeleteModal';
import DeductionPolicyForm from './DeductionPolicyForm';
import DeductionPolicyCreate from './DeductionPolicyCreate';
import DeductionPolicyUpdate from './DeductionPolicyUpdate';
import DeductionPolicyApp from '../Functionality/DeductionPolicyApp';

/**
 * @Email : kpozos@ibl.mx
 * @Author: Karen Yunuen Pozos Arias
 * @jobTitle: Full Stack Developer
 */
const DeductionPolicySection = ({ registerAction, subView }) => {
    const {
        t,
        canCreate,
        canUpdate,
        canDelete,
        items,
        getData,
        selectedItem,
        setSelectedItem,
        showCreateModal,
        setShowCreateModal,
        showUpdateModal,
        setShowUpdateModal,
        showDeleteModal,
        setShowDeleteModal,
        handleCreate,
        handleOpenUpdate,
        handleOpenDelete,
        handleSubmitDelete,
    } = DeductionPolicyApp({ registerAction, subView });

    return (
        <>
            <div className='row px-0'>
                {items?.length > 0 ? (
                    items.map((row, index) => (
                        <div key={row.id ?? index} className='col-12'>
                            <div className='d-flex justify-content-between align-items-center my-4'>
                                <h5 className='ibl-h5 font-color-general-950 ibl-font-w-600'>
                                    {`${t('deduction_policy')} ${(index + 1).toString().padStart(2, '0')}`}
                                </h5>
                                <div className='d-flex align-items-center gap-3'>
                                    {canUpdate && (
                                        <ButtonIcon
                                            id={`btn_dps_update_${row.id}`}
                                            Icon={EditIcon}
                                            title='update'
                                            className='btn-icon-export'
                                            iconProps='btn-icon-svg-12px icon-color-general-00'
                                            onClick={() => handleOpenUpdate(row)}
                                        />
                                    )}
                                    {canDelete && (
                                        <ButtonIcon
                                            id={`btn_dps_delete_${row.id}`}
                                            Icon={TrashOutlineIcon}
                                            title='delete'
                                            className='btn-icon-delete'
                                            iconProps='btn-icon-svg-12px icon-color-general-00'
                                            onClick={() => handleOpenDelete(row)}
                                        />
                                    )}
                                </div>
                            </div>

                            <DeductionPolicyForm
                                item={row}
                                disabled
                                idSuffix={row.id}
                            />
                        </div>
                    ))
                ) : (
                    <div className='mt-4'>
                        <NotInformation card={true}>
                            <div className='warning-text'>
                                <p>{t('you_haven_not_created_any_deduction_policy_yet')}</p>
                            </div>
                            {canCreate && (
                                <CustomButtonLink
                                    splitName={false}
                                    id='btn_dps_create_link'
                                    card
                                    onClick={handleCreate}
                                    name='create_deduction_policy'
                                />
                            )}
                        </NotInformation>
                    </div>
                )}
            </div>

            <DeductionPolicyCreate
                show={showCreateModal}
                onHide={() => setShowCreateModal(false)}
                onSuccess={getData}
            />

            <DeductionPolicyUpdate
                show={showUpdateModal}
                row={selectedItem}
                onHide={() => setShowUpdateModal(false)}
                onSuccess={getData}
            />

            {showDeleteModal && (
                <DeleteModal
                    show={showDeleteModal}
                    onHide={() => {
                        setShowDeleteModal(false);
                        setSelectedItem(null);
                    }}
                    onClickFn={handleSubmitDelete}
                    data={selectedItem ? [selectedItem] : []}
                    title_modal={t('delete_deduction_policy')}
                    element_modal={t('deduction_policy')}
                    buttonCancelText='cancel'
                />
            )}
        </>
    );
};

export default DeductionPolicySection;
